import React from 'react';
import styled from 'styled-components';
import { useGlobalContext } from '../../context/sidebar_context';
import { NavLink } from 'react-router-dom';



export default function Sidebar() {
  const { isSidebarOpen } = useGlobalContext();
  // const sidebarRef = useRef(null);
  // OutsideClick(sidebarRef);



  return (
    // <SidebarContainer ref={sidebarRef} >
    <SidebarContainer  >
      <aside
        className={`${isSidebarOpen ? 'sidebar show-sidebar' : 'sidebar'}`}
      >
        <div className="sidebar-header">
          <svg className="logo" xmlns="http://www.w3.org/2000/svg" width="118" height="50" viewBox="0 0 118 50">
            <g id="Group_377" data-name="Group 377" transform="translate(-24 -17)">
              <text id="Logo" transform="translate(84 50.5)" fill="#fff" fontSize="24" fontFamily="Poppins-SemiBold, Poppins" fontWeight="600"><tspan x="0" y="0">BridIT</tspan></text>
              <circle id="Ellipse_171" data-name="Ellipse 171" cx="25" cy="25" r="25" transform="translate(24 17)" fill="#fff" />
            </g>
          </svg>

          <button
            className={`${isSidebarOpen ? 'close-btn' : 'd-none'}`}
            type="button"

          >
            {/* <svg className="burger" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="49" height="49" viewBox="0 0 49 49">
              <defs>
                <clipPath id="clip-path">
                  <rect id="Rectangle_365" data-name="Rectangle 365" width="20" height="20" transform="translate(374 19)" fill="#fff" stroke="#1a1a1a" strokeWidth="1" />
                </clipPath>
              </defs>
              <g id="Group_402" data-name="Group 402" transform="translate(-325 -18)">
                <circle id="Ellipse_172" data-name="Ellipse 172" cx="24.5" cy="24.5" r="24.5" transform="translate(325 18)" fill="white" />
                <g id="Mask_Group_1" data-name="Mask Group 1" transform="translate(-34 13)" clipPath="url(#clip-path)">
                  <g id="menu-svgrepo-com" transform="translate(374 22.516)">
                    <g id="Menu">
                      <path id="Path_9201" data-name="Path 9201" d="M.609,8.438H18.87a.661.661,0,0,0,.609-.7.661.661,0,0,0-.609-.7H.609a.661.661,0,0,0-.609.7A.661.661,0,0,0,.609,8.438Z" transform="translate(0 -7.031)" fill="#2e4765" opacity="0.82" />
                      <path id="Path_9202" data-name="Path 9202" d="M15.125,21.094H.488c-.269,0-.488.315-.488.7s.219.7.488.7H15.125c.269,0,.488-.315.488-.7S15.395,21.094,15.125,21.094Z" transform="translate(0 -14.687)" fill="#2e4765" opacity="0.82" />
                      <path id="Path_9203" data-name="Path 9203" d="M18.87,35.156H.609a.71.71,0,0,0,0,1.406H18.87a.71.71,0,0,0,0-1.406Z" transform="translate(0 -22.343)" fill="#2e4765" opacity="0.82" />
                    </g>
                  </g>
                </g>
              </g>
            </svg> */}

            {/* <img src={burger} className="burger" alt="menu" /> */}
          </button>
        </div>
        <p className="subtitle ps-4 mb-1">Main</p>
        <hr />
        <ul className="links">
          <li className="pt-2">
            <NavLink to="dashboard"  >
              <svg
                id="dashboard-svgrepo-com"
                xmlns="http://www.w3.org/2000/svg"
                width="19"
                height="15.833"
                viewBox="0 0 19 15.833"
              >
                <g id="Group_352" data-name="Group 352">
                  <g id="Group_351" data-name="Group 351">
                    <path
                      id="Path_9204"
                      data-name="Path 9204"
                      d="M9.5,2.334h0A9.47,9.47,0,0,0,2.784,5.114l0,0,0,0A9.47,9.47,0,0,0,0,11.825s0,.006,0,.008,0,.005,0,.008a9.462,9.462,0,0,0,2.171,6.038.792.792,0,0,0,.61.288H16.217a.792.792,0,0,0,.61-.288A9.5,9.5,0,0,0,9.5,2.334Zm6.333,14.25H3.166a7.866,7.866,0,0,1-1.543-3.958H3.958a.792.792,0,0,0,0-1.583H1.623A7.879,7.879,0,0,1,3.37,6.824l.531.531a.792.792,0,1,0,1.12-1.12L4.49,5.7A7.879,7.879,0,0,1,8.708,3.956V6.292a.792.792,0,0,0,1.583,0V3.956A7.88,7.88,0,0,1,14.51,5.7l-.532.532a.792.792,0,1,0,1.12,1.12l.532-.532a7.88,7.88,0,0,1,1.748,4.218H15.041a.792.792,0,0,0,0,1.583h2.336A7.867,7.867,0,0,1,15.834,16.583Z"
                      transform="translate(0 -2.334)"
                      fill="#fff"
                    />
                    <path
                      id="Path_9205"
                      data-name="Path 9205"
                      d="M15.378,12.067,10.9,14.306l2.239,2.239Z"
                      transform="translate(-3.504 -5.462)"
                      fill="#fff"
                    />
                    <path
                      id="Path_9206"
                      data-name="Path 9206"
                      d="M14.875,19.833h-4.75a.792.792,0,1,0,0,1.583h4.75a.792.792,0,1,0,0-1.583Z"
                      transform="translate(-3 -7.958)"
                      fill="#fff"
                    />
                  </g>
                </g>
              </svg>

              <span className=" ">Dashboard</span>
            </NavLink>
          </li>
          <li>
            <NavLink to="bridal-entry"  >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="19.5"
                height="18.313"
                viewBox="0 0 19.5 18.313"
              >
                <path
                  id="Path_17"
                  data-name="Path 17"
                  d="M16.551,16H2.449A2.452,2.452,0,0,0,0,18.449V31.363a2.452,2.452,0,0,0,2.449,2.449H14.844a2.726,2.726,0,0,0,1.94-.8L18.2,31.6a2.726,2.726,0,0,0,.8-1.94V18.449A2.452,2.452,0,0,0,16.551,16Zm-14.1,1.187h14.1a1.263,1.263,0,0,1,1.262,1.262v1.707H1.188V18.449A1.263,1.263,0,0,1,2.449,17.187ZM1.188,31.363V21.344H17.813v7.719H15.957A1.709,1.709,0,0,0,14.25,30.77v1.855H2.449A1.263,1.263,0,0,1,1.188,31.363Zm16.169-.606-1.412,1.412a1.554,1.554,0,0,1-.507.339V30.77a.52.52,0,0,1,.52-.52H17.7A1.555,1.555,0,0,1,17.357,30.757Z"
                  transform="translate(0.25 -15.75)"
                  fill="#fff"
                  stroke="#fff"
                  strokeWidth="0.5"
                />
              </svg>

              <span className=" ">Bridal Entry Database</span>
            </NavLink>
          </li>
          <li>
            <NavLink to="calendar"  >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="19"
                height="20.9"
                viewBox="0 0 19 20.9"
              >
                <path
                  id="calendar"
                  d="M11.5,18.1a.95.95,0,1,0-.95-.95A.95.95,0,0,0,11.5,18.1Zm4.75,0a.95.95,0,1,0-.95-.95A.95.95,0,0,0,16.25,18.1Zm0-3.8a.95.95,0,1,0-.95-.95A.95.95,0,0,0,16.25,14.3Zm-4.75,0a.95.95,0,1,0-.95-.95A.95.95,0,0,0,11.5,14.3ZM18.15,2.9H17.2V1.95a.95.95,0,1,0-1.9,0V2.9H7.7V1.95a.95.95,0,0,0-1.9,0V2.9H4.85A2.85,2.85,0,0,0,2,5.75v13.3A2.85,2.85,0,0,0,4.85,21.9h13.3A2.85,2.85,0,0,0,21,19.05V5.75A2.85,2.85,0,0,0,18.15,2.9Zm.95,16.15a.95.95,0,0,1-.95.95H4.85a.95.95,0,0,1-.95-.95V10.5H19.1Zm0-10.45H3.9V5.75a.95.95,0,0,1,.95-.95H5.8v.95a.95.95,0,1,0,1.9,0V4.8h7.6v.95a.95.95,0,1,0,1.9,0V4.8h.95a.95.95,0,0,1,.95.95ZM6.75,14.3a.95.95,0,1,0-.95-.95A.95.95,0,0,0,6.75,14.3Zm0,3.8a.95.95,0,1,0-.95-.95A.95.95,0,0,0,6.75,18.1Z"
                  transform="translate(-2 -1)"
                  fill="#ffff"
                />
              </svg>
              <span className=" ">Calendar</span>
            </NavLink>
          </li>
          <li>
            <NavLink to="orders"  >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="22"
                height="22"
                viewBox="0 0 22 22"
              >
                <defs>
                  <clipPath id="clipPath">
                    <rect
                      id="Rectangle_579"
                      data-name="Rectangle 579"
                      width="22"
                      height="22"
                      fill="#fff"
                    />
                  </clipPath>
                </defs>
                <g
                  id="Group_480"
                  data-name="Group 480"
                  clipPath="url(#clipPath)"
                >
                  <path
                    id="Path_9735"
                    data-name="Path 9735"
                    d="M18.84,21.222A2.063,2.063,0,1,0,20.9,23.285,2.063,2.063,0,0,0,18.84,21.222Zm0,1.375a.688.688,0,1,1-.688.688A.688.688,0,0,1,18.84,22.6Z"
                    transform="translate(-3.028 -3.347)"
                    fill="#fff"
                    fillRule="evenodd"
                  />
                  <path
                    id="Path_9736"
                    data-name="Path 9736"
                    d="M18.84,21.222A2.063,2.063,0,1,0,20.9,23.285,2.063,2.063,0,0,0,18.84,21.222Zm0,1.375a.688.688,0,1,1-.688.688A.688.688,0,0,1,18.84,22.6Z"
                    transform="translate(-12.653 -3.347)"
                    fill="#fff"
                    fillRule="evenodd"
                  />
                  <path
                    id="Path_9737"
                    data-name="Path 9737"
                    d="M19.187,15.125H4.062a.688.688,0,0,1-.687-.688V.688A.687.687,0,1,0,2,.688v13.75A2.063,2.063,0,0,0,4.062,16.5H19.187a.688.688,0,0,0,0-1.375Z"
                    transform="translate(0.063)"
                    fill="#fff"
                    fillRule="evenodd"
                  />
                  <path
                    id="Path_9738"
                    data-name="Path 9738"
                    d="M16.222,0a.688.688,0,0,0-.688-.688H5.91A.688.688,0,0,0,5.222,0V4.128a.688.688,0,0,0,.688.688h9.625a.688.688,0,0,0,.688-.688ZM6.6.691v2.75h8.25V.691Z"
                    transform="translate(0.965 8.934)"
                    fill="#fff"
                    fillRule="evenodd"
                  />
                  <path
                    id="Path_9739"
                    data-name="Path 9739"
                    d="M247.941,58.366a.688.688,0,0,0-.608-.366H237.87a.688.688,0,0,0-.608.366l-1.456,2.75a.688.688,0,0,0,.607,1.009h12.375a.688.688,0,0,0,.608-1.009Zm-9.657,1.009-.728,1.375h10.092l-.728-1.375Z"
                    transform="translate(-230.914 -52.501)"
                    fill="#fff"
                    fillRule="evenodd"
                  />
                  <path
                    id="Path_9740"
                    data-name="Path 9740"
                    d="M0,.688v2.75a.688.688,0,1,0,1.375,0V.688A.688.688,0,1,0,0,.688Z"
                    transform="translate(12.375 4.125) rotate(180)"
                    fill="#fff"
                    fillRule="evenodd"
                  />
                  <path
                    id="Path_9741"
                    data-name="Path 9741"
                    d="M17.174,4.549l1.375-1.375a.688.688,0,0,0-.972-.972L16.2,3.576a.688.688,0,0,0,.972.972Z"
                    transform="translate(-5 -0.625)"
                    fill="#fff"
                    fillRule="evenodd"
                  />
                  <path
                    id="Path_9742"
                    data-name="Path 9742"
                    d="M16.548,3.576,15.173,2.2a.688.688,0,0,0-.972.972l1.375,1.375a.688.688,0,0,0,.972-.972Z"
                    transform="translate(-4.375 -0.625)"
                    fill="#fff"
                    fillRule="evenodd"
                  />
                </g>
              </svg>
              <span className=" ">Orders</span>
            </NavLink>
          </li>
          <li>
            <NavLink to="status-orders"  >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="22"
                height="22"
                viewBox="0 0 22 22"
              >
                <defs>
                  <clipPath id="clipPath">
                    <rect
                      id="Rectangle_579"
                      data-name="Rectangle 579"
                      width="22"
                      height="22"
                      fill="#fff"
                    />
                  </clipPath>
                </defs>
                <g
                  id="Group_480"
                  data-name="Group 480"
                  clipPath="url(#clipPath)"
                >
                  <path
                    id="Path_9735"
                    data-name="Path 9735"
                    d="M18.84,21.222A2.063,2.063,0,1,0,20.9,23.285,2.063,2.063,0,0,0,18.84,21.222Zm0,1.375a.688.688,0,1,1-.688.688A.688.688,0,0,1,18.84,22.6Z"
                    transform="translate(-3.028 -3.347)"
                    fill="#fff"
                    fillRule="evenodd"
                  />
                  <path
                    id="Path_9736"
                    data-name="Path 9736"
                    d="M18.84,21.222A2.063,2.063,0,1,0,20.9,23.285,2.063,2.063,0,0,0,18.84,21.222Zm0,1.375a.688.688,0,1,1-.688.688A.688.688,0,0,1,18.84,22.6Z"
                    transform="translate(-12.653 -3.347)"
                    fill="#fff"
                    fillRule="evenodd"
                  />
                  <path
                    id="Path_9737"
                    data-name="Path 9737"
                    d="M19.187,15.125H4.062a.688.688,0,0,1-.687-.688V.688A.687.687,0,1,0,2,.688v13.75A2.063,2.063,0,0,0,4.062,16.5H19.187a.688.688,0,0,0,0-1.375Z"
                    transform="translate(0.063)"
                    fill="#fff"
                    fillRule="evenodd"
                  />
                  <path
                    id="Path_9738"
                    data-name="Path 9738"
                    d="M16.222,0a.688.688,0,0,0-.688-.688H5.91A.688.688,0,0,0,5.222,0V4.128a.688.688,0,0,0,.688.688h9.625a.688.688,0,0,0,.688-.688ZM6.6.691v2.75h8.25V.691Z"
                    transform="translate(0.965 8.934)"
                    fill="#fff"
                    fillRule="evenodd"
                  />
                  <path
                    id="Path_9739"
                    data-name="Path 9739"
                    d="M247.941,58.366a.688.688,0,0,0-.608-.366H237.87a.688.688,0,0,0-.608.366l-1.456,2.75a.688.688,0,0,0,.607,1.009h12.375a.688.688,0,0,0,.608-1.009Zm-9.657,1.009-.728,1.375h10.092l-.728-1.375Z"
                    transform="translate(-230.914 -52.501)"
                    fill="#fff"
                    fillRule="evenodd"
                  />
                  <path
                    id="Path_9740"
                    data-name="Path 9740"
                    d="M0,.688v2.75a.688.688,0,1,0,1.375,0V.688A.688.688,0,1,0,0,.688Z"
                    transform="translate(12.375 4.125) rotate(180)"
                    fill="#fff"
                    fillRule="evenodd"
                  />
                  <path
                    id="Path_9741"
                    data-name="Path 9741"
                    d="M17.174,4.549l1.375-1.375a.688.688,0,0,0-.972-.972L16.2,3.576a.688.688,0,0,0,.972.972Z"
                    transform="translate(-5 -0.625)"
                    fill="#fff"
                    fillRule="evenodd"
                  />
                  <path
                    id="Path_9742"
                    data-name="Path 9742"
                    d="M16.548,3.576,15.173,2.2a.688.688,0,0,0-.972.972l1.375,1.375a.688.688,0,0,0,.972-.972Z"
                    transform="translate(-4.375 -0.625)"
                    fill="#fff"
                    fillRule="evenodd"
                  />
                </g>
              </svg>
              <span className=" ">Status of Orders</span>
            </NavLink>
          </li>
          <li>
            <NavLink to="inventory"  >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="19.5"
                height="19.5"
                viewBox="0 0 19.5 19.5"
              >
                <g
                  id="Group_825"
                  data-name="Group 825"
                  transform="translate(-3760.75 13073.25)"
                >
                  <g
                    id="Group_676"
                    data-name="Group 676"
                    transform="translate(3723 -13481)"
                  >
                    <path
                      id="Path_9743"
                      data-name="Path 9743"
                      d="M17.021,0H1.979A1.979,1.979,0,0,0,0,1.979V17.021A1.979,1.979,0,0,0,1.979,19H17.021A1.979,1.979,0,0,0,19,17.021V1.979A1.979,1.979,0,0,0,17.021,0ZM6.729.792h5.542V6.333H6.729Zm0,6.333h5.542v.792H6.729Zm11.479,9.9a1.188,1.188,0,0,1-1.187,1.188H1.979A1.188,1.188,0,0,1,.792,17.021V1.979A1.188,1.188,0,0,1,1.979.792H5.938V8.313a.4.4,0,0,0,.4.4h6.333a.4.4,0,0,0,.4-.4V.792h3.958a1.188,1.188,0,0,1,1.188,1.188Z"
                      transform="translate(38 408)"
                      fill="#fff"
                      stroke="#fff"
                      strokeWidth="0.5"
                    />
                    <path
                      id="Path_9744"
                      data-name="Path 9744"
                      d="M8.771,34H6.4a.4.4,0,0,0-.4.4v2.375a.4.4,0,0,0,.4.4H8.771a.4.4,0,0,0,.4-.4V34.4A.4.4,0,0,0,8.771,34Zm-.4,2.375H6.792V34.792H8.375Z"
                      transform="translate(34.375 387.458)"
                      fill="#fff"
                      stroke="#fff"
                      strokeWidth="0.5"
                    />
                    <rect
                      id="Rectangle_610"
                      data-name="Rectangle 610"
                      width="1.122"
                      height="1.122"
                      transform="translate(44.732 421.465)"
                      fill="#fff"
                      stroke="#fff"
                      strokeWidth="0.5"
                    />
                    <rect
                      id="Rectangle_611"
                      data-name="Rectangle 611"
                      width="1.122"
                      height="1.122"
                      transform="translate(45.854 421.465)"
                      fill="#fff"
                      stroke="#fff"
                      strokeWidth="0.5"
                    />
                    <rect
                      id="Rectangle_612"
                      data-name="Rectangle 612"
                      width="4.488"
                      transform="translate(44.732 423.708)"
                      fill="#fff"
                      stroke="#fff"
                      strokeWidth="0.5"
                    />
                  </g>
                </g>
              </svg>

              <span className=" ">Inventory</span>
            </NavLink>
          </li>
          <li>
            <NavLink to="previous-inventory"  >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="19.5"
                height="19.5"
                viewBox="0 0 19.5 19.5"
              >
                <g
                  id="Group_825"
                  data-name="Group 825"
                  transform="translate(-3760.75 13073.25)"
                >
                  <g
                    id="Group_676"
                    data-name="Group 676"
                    transform="translate(3723 -13481)"
                  >
                    <path
                      id="Path_9743"
                      data-name="Path 9743"
                      d="M17.021,0H1.979A1.979,1.979,0,0,0,0,1.979V17.021A1.979,1.979,0,0,0,1.979,19H17.021A1.979,1.979,0,0,0,19,17.021V1.979A1.979,1.979,0,0,0,17.021,0ZM6.729.792h5.542V6.333H6.729Zm0,6.333h5.542v.792H6.729Zm11.479,9.9a1.188,1.188,0,0,1-1.187,1.188H1.979A1.188,1.188,0,0,1,.792,17.021V1.979A1.188,1.188,0,0,1,1.979.792H5.938V8.313a.4.4,0,0,0,.4.4h6.333a.4.4,0,0,0,.4-.4V.792h3.958a1.188,1.188,0,0,1,1.188,1.188Z"
                      transform="translate(38 408)"
                      fill="#fff"
                      stroke="#fff"
                      strokeWidth="0.5"
                    />
                    <path
                      id="Path_9744"
                      data-name="Path 9744"
                      d="M8.771,34H6.4a.4.4,0,0,0-.4.4v2.375a.4.4,0,0,0,.4.4H8.771a.4.4,0,0,0,.4-.4V34.4A.4.4,0,0,0,8.771,34Zm-.4,2.375H6.792V34.792H8.375Z"
                      transform="translate(34.375 387.458)"
                      fill="#fff"
                      stroke="#fff"
                      strokeWidth="0.5"
                    />
                    <rect
                      id="Rectangle_610"
                      data-name="Rectangle 610"
                      width="1.122"
                      height="1.122"
                      transform="translate(44.732 421.465)"
                      fill="#fff"
                      stroke="#fff"
                      strokeWidth="0.5"
                    />
                    <rect
                      id="Rectangle_611"
                      data-name="Rectangle 611"
                      width="1.122"
                      height="1.122"
                      transform="translate(45.854 421.465)"
                      fill="#fff"
                      stroke="#fff"
                      strokeWidth="0.5"
                    />
                    <rect
                      id="Rectangle_612"
                      data-name="Rectangle 612"
                      width="4.488"
                      transform="translate(44.732 423.708)"
                      fill="#fff"
                      stroke="#fff"
                      strokeWidth="0.5"
                    />
                  </g>
                </g>
              </svg>
              <span className=" ">Previous Inventory</span>
            </NavLink>
          </li>
          <li>
            <NavLink to="inventory-report"  >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="19"
                height="14.929"
                viewBox="0 0 19 14.929"
              >
                <path
                  id="bar_chart_graph_analysis"
                  d="M19.643,18.571V8.393a.679.679,0,0,0-.679-.679H16.25a.679.679,0,0,0-.679.679V18.571H14.214V5.679A.679.679,0,0,0,13.536,5H10.821a.679.679,0,0,0-.679.679V18.571H8.786V11.786a.679.679,0,0,0-.679-.679H5.393a.679.679,0,0,0-.679.679v6.786H3.357V5H2V19.25a.679.679,0,0,0,.679.679H21V18.571Zm-2.714-9.5h1.357v9.5H16.929ZM11.5,6.357h1.357V18.571H11.5ZM6.071,12.464H7.429v6.107H6.071Z"
                  transform="translate(-2 -5)"
                  fill="#fff"
                />
              </svg>

              <span className=" ">Inventory Report</span>
            </NavLink>
          </li>
          <li>
            <NavLink to="payment-list"  >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="16"
                viewBox="0 0 20 16"
              >
                <g
                  id="Group_827"
                  data-name="Group 827"
                  transform="translate(-3760 12925)"
                >
                  <g
                    id="Group_679"
                    data-name="Group 679"
                    transform="translate(3723 -13477)"
                  >
                    <g id="payment" transform="translate(35 548)">
                      <path
                        id="Path_9752"
                        data-name="Path 9752"
                        d="M6,14.25a.75.75,0,0,0,0,1.5h6a.75.75,0,0,0,0-1.5Z"
                        fill="#fff"
                      />
                      <path
                        id="Path_9753"
                        data-name="Path 9753"
                        d="M5,4A3,3,0,0,0,2,7V17a3,3,0,0,0,3,3H19a3,3,0,0,0,3-3V7a3,3,0,0,0-3-3ZM19,5.5H5A1.5,1.5,0,0,0,3.5,7V8.25h17V7A1.5,1.5,0,0,0,19,5.5ZM3.5,17V9.75h17V17A1.5,1.5,0,0,1,19,18.5H5A1.5,1.5,0,0,1,3.5,17Z"
                        fill="#fff"
                        fillRule="evenodd"
                      />
                    </g>
                  </g>
                </g>
              </svg>

              <span className=" ">Payment Transactions</span>
            </NavLink>
          </li>
          <li>
            <NavLink to="refund-list"  >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
              >
                <g
                  id="Group_828"
                  data-name="Group 828"
                  transform="translate(-3760 12880)"
                >
                  <g
                    id="Group_680"
                    data-name="Group 680"
                    transform="translate(3723 -13477)"
                  >
                    <g id="money" transform="translate(36 596)">
                      <path
                        id="Path_9754"
                        data-name="Path 9754"
                        d="M13.333,11.667a5.333,5.333,0,1,1,5.333-5.333A5.34,5.34,0,0,1,13.333,11.667Zm0-9.333a4,4,0,1,0,4,4A4,4,0,0,0,13.333,2.333Z"
                        transform="translate(-2.333)"
                        fill="#fff"
                      />
                      <path
                        id="Path_9755"
                        data-name="Path 9755"
                        d="M15.267,10.4h-.533a1.742,1.742,0,0,1-1.662-1.243.666.666,0,1,1,1.279-.377.4.4,0,0,0,.383.287h.533a.4.4,0,0,0,0-.8h-.533a1.733,1.733,0,1,1,0-3.467h.533a1.73,1.73,0,0,1,1.644,1.185.667.667,0,1,1-1.265.422.4.4,0,0,0-.379-.274h-.533a.4.4,0,1,0,0,.8h.533a1.733,1.733,0,1,1,0,3.467Z"
                        transform="translate(-4 -1.267)"
                        fill="#fff"
                      />
                      <path
                        id="Path_9756"
                        data-name="Path 9756"
                        d="M11,5.338a.686.686,0,0,1-.473-.193.637.637,0,0,1-.08-.107.371.371,0,0,1-.06-.113.448.448,0,0,1-.041-.12,1,1,0,0,1-.013-.133.667.667,0,1,1,1.333,0,.823.823,0,0,1-.014.133.4.4,0,0,1-.04.12.386.386,0,0,1-.06.113c-.027.04-.053.073-.08.107A.7.7,0,0,1,11,5.338Zm0,5.333a.686.686,0,0,1-.473-.193.637.637,0,0,1-.08-.107.371.371,0,0,1-.06-.113.448.448,0,0,1-.041-.12A1,1,0,0,1,10.333,10a.667.667,0,1,1,1.333,0,.823.823,0,0,1-.014.133.4.4,0,0,1-.04.12.386.386,0,0,1-.06.113c-.027.04-.053.073-.08.107A.7.7,0,0,1,11,10.671ZM12.333,22H1.667A.666.666,0,0,1,1,21.337v-6a.665.665,0,0,1,.2-.471,5.166,5.166,0,0,1,3.138-1.529,8.051,8.051,0,0,1,3.53,1.333H11a2,2,0,0,1,2,2,2.042,2.042,0,0,1-.03.346l5.261-2.192A2,2,0,0,1,21,16.671a.666.666,0,0,1-.331.576l-8,4.667A.668.668,0,0,1,12.333,22Zm-10-1.333h9.819l7.427-4.332a.673.673,0,0,0-.209-.223.656.656,0,0,0-.626-.061l-6.153,2.564a.671.671,0,0,1-.257.051H7a.667.667,0,1,1,0-1.333h4A.667.667,0,1,0,11,16H7.667a.675.675,0,0,1-.37-.111,7.313,7.313,0,0,0-2.963-1.222,3.633,3.633,0,0,0-2,.959Z"
                        transform="translate(0 -1.004)"
                        fill="#fff"
                      />
                    </g>
                  </g>
                </g>
              </svg>

              <span className=" ">Refund Transactions</span>
            </NavLink>
          </li>
          <li>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
            >
              <path
                id="clock"
                d="M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20Zm1-8.251V7a1,1,0,0,0-2,0v5a1.006,1.006,0,0,0,.118.472l1.5,2.8a1,1,0,1,0,1.764-.944Z"
                transform="translate(-2 -2)"
                fill="#ffff"
              />
            </svg>
            <span className=" ">Hours</span>
          </li>
          <li>
            <NavLink to="book-keeping"  >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
              >
                <path
                  id="bookmark-in-book"
                  d="M21,6a1,1,0,0,0-1,1V17a3,3,0,0,1-3,3H7a1,1,0,0,0,0,2H17a5,5,0,0,0,5-5V7A1,1,0,0,0,21,6Zm-3,9V5a3,3,0,0,0-3-3H5A3,3,0,0,0,2,5V15a3,3,0,0,0,3,3H15A3,3,0,0,0,18,15ZM10,4h2V8.86l-.36-.3a1,1,0,0,0-1.28,0l-.36.3ZM4,15V5A1,1,0,0,1,5,4H8v7a1,1,0,0,0,1.65.76L11,10.63l1.35,1.13A1,1,0,0,0,13,12a1.06,1.06,0,0,0,.42-.09A1,1,0,0,0,14,11V4h1a1,1,0,0,1,1,1V15a1,1,0,0,1-1,1H5A1,1,0,0,1,4,15Z"
                  transform="translate(-2 -2)"
                  fill="#fff"
                />
              </svg>

              <span className=" ">Book Keeping</span>
            </NavLink>
          </li>
          <li>
            <NavLink to="templates"  >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16.475"
                height="22.466"
                viewBox="0 0 16.475 22.466"
              >
                <g id="payment" transform="translate(-5 -1)">
                  <path
                    id="Path_9789"
                    data-name="Path 9789"
                    d="M19.228,1H7.247A2.247,2.247,0,0,0,5,3.247V9.237a.749.749,0,0,0,.749.749h1.5V21.219a2.247,2.247,0,0,0,2.247,2.247h7.489a2.247,2.247,0,0,0,2.247-2.247V9.986h1.5a.749.749,0,0,0,.749-.749V3.247A2.247,2.247,0,0,0,19.228,1Zm-1.5,20.219a.749.749,0,0,1-.749.749H9.493a.749.749,0,0,1-.749-.749V9.986h8.986ZM19.977,8.489H6.5V3.247A.749.749,0,0,1,7.247,2.5H19.228a.749.749,0,0,1,.749.749Z"
                    fill="#fff"
                  />
                  <path
                    id="Path_9790"
                    data-name="Path 9790"
                    d="M14.545,17.091A2.545,2.545,0,1,0,12,14.545,2.545,2.545,0,0,0,14.545,17.091Zm0-3.818a1.273,1.273,0,1,1-1.273,1.273A1.273,1.273,0,0,1,14.545,13.273ZM18.364,5h-.636a.636.636,0,1,0,0,1.273h.636a.636.636,0,1,0,0-1.273ZM15.818,5h-.636a.636.636,0,0,0,0,1.273h.636a.636.636,0,1,0,0-1.273Z"
                    transform="translate(-1.2 -0.625)"
                    fill="#fff"
                  />
                </g>
              </svg>

              <span className=" ">Templates</span>
            </NavLink>
          </li>
          <li>
            <NavLink to="analytics"  >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18.85"
                height="18.86"
                viewBox="0 0 18.85 18.86"
              >
                <path
                  id="Path_9786"
                  data-name="Path 9786"
                  d="M34.641,23.326H28.3V17.764a7.88,7.88,0,0,1,5.085,4.256.629.629,0,0,0,1.138-.534,9.136,9.136,0,0,0-6.746-5.121.627.627,0,0,0-.732.62v6.97a.627.627,0,0,0,.628.629h6.969a.629.629,0,1,0,0-1.257ZM32.128,26.42H25.217V21.576a.629.629,0,0,0-1.257,0v5.473a.627.627,0,0,0,.629.628h6.883a6.912,6.912,0,1,1-6.883-7.54.628.628,0,1,0,0-1.257,8.168,8.168,0,1,0,8.168,8.169A.627.627,0,0,0,32.128,26.42Z"
                  transform="translate(-16.42 -16.356)"
                  fill="#fff"
                />
              </svg>

              <span className=" ">Analytics</span>
            </NavLink>
          </li>
          <li className="">
            <svg xmlns="http://www.w3.org/2000/svg" width="16.475" height="22.466" viewBox="0 0 16.475 22.466">
              <g id="payment" transform="translate(-5 -1)">
                <path id="Path_9789" data-name="Path 9789" d="M19.228,1H7.247A2.247,2.247,0,0,0,5,3.247V9.237a.749.749,0,0,0,.749.749h1.5V21.219a2.247,2.247,0,0,0,2.247,2.247h7.489a2.247,2.247,0,0,0,2.247-2.247V9.986h1.5a.749.749,0,0,0,.749-.749V3.247A2.247,2.247,0,0,0,19.228,1Zm-1.5,20.219a.749.749,0,0,1-.749.749H9.493a.749.749,0,0,1-.749-.749V9.986h8.986ZM19.977,8.489H6.5V3.247A.749.749,0,0,1,7.247,2.5H19.228a.749.749,0,0,1,.749.749Z" fill="#fff" />
                <path id="Path_9790" data-name="Path 9790" d="M14.545,17.091A2.545,2.545,0,1,0,12,14.545,2.545,2.545,0,0,0,14.545,17.091Zm0-3.818a1.273,1.273,0,1,1-1.273,1.273A1.273,1.273,0,0,1,14.545,13.273ZM18.364,5h-.636a.636.636,0,1,0,0,1.273h.636a.636.636,0,1,0,0-1.273ZM15.818,5h-.636a.636.636,0,0,0,0,1.273h.636a.636.636,0,1,0,0-1.273Z" transform="translate(-1.2 -0.625)" fill="#fff" />
              </g>
            </svg>

            <span className=" ">Charging Appointments</span>
          </li>
        </ul>
        <hr />
        <ul className="links">
          <li className="pt-2">
            <svg xmlns="http://www.w3.org/2000/svg" width="19" height="20" viewBox="0 0 19 20">
              <path id="setting" d="M.873,5.163a.8.8,0,0,1,.589.116A.745.745,0,0,1,1.687,6.3h0l-.057.111a1.051,1.051,0,0,0,.461,1.338,2.587,2.587,0,0,1-.036,4.471,1.049,1.049,0,0,0-.4,1.449h0l.621,1.045a1.067,1.067,0,0,0,.662.5,1.092,1.092,0,0,0,.831-.118,2.647,2.647,0,0,1,1.322-.342,2.667,2.667,0,0,1,2.7,2.635,1.085,1.085,0,0,0,1.1,1.063h0l-.009.018a.786.786,0,0,1,.678.382.749.749,0,0,1,0,.764A.786.786,0,0,1,8.874,20a2.667,2.667,0,0,1-2.7-2.635.992.992,0,0,0-.144-.527,1.112,1.112,0,0,0-1.493-.4h0l-.16.079A2.734,2.734,0,0,1,.94,15.494h0L.329,14.449A2.6,2.6,0,0,1,1.3,10.935a1.1,1.1,0,0,0,.4-.386,1.043,1.043,0,0,0,.178-.85A1.065,1.065,0,0,0,1.345,9h0l-.15-.1A2.6,2.6,0,0,1,.374,5.49h0l.077-.1A.788.788,0,0,1,.873,5.163ZM17,7.7a.81.81,0,0,1,.957.335.754.754,0,0,1-.27,1.045,1.1,1.1,0,0,0-.4.386,1.041,1.041,0,0,0-.113.809,1.067,1.067,0,0,0,.509.649,2.6,2.6,0,0,1,.936,3.6h0l-.612,1.045-.1.146a2.739,2.739,0,0,1-3.5.8,1.1,1.1,0,0,0-1.1-.011,1.049,1.049,0,0,0-.54.933.794.794,0,0,1-1.574,0,2.626,2.626,0,0,1,1.346-2.227,2.755,2.755,0,0,1,2.648-.031,1.093,1.093,0,0,0,.828.114,1.121,1.121,0,0,0,.666-.5h0l.612-1.045a1.032,1.032,0,0,0,.112-.805,1.058,1.058,0,0,0-.508-.644,2.57,2.57,0,0,1-.98-1.045A2.6,2.6,0,0,1,16.9,7.747h0Zm-7.507-1a3.415,3.415,0,0,1,2.391.962A3.255,3.255,0,0,1,12.876,10h0l-.006.2a3.308,3.308,0,0,1-2.076,2.858,3.442,3.442,0,0,1-3.689-.71,3.246,3.246,0,0,1-.737-3.6A3.384,3.384,0,0,1,9.494,6.7Zm0,1.546A1.757,1.757,0,1,0,11.293,10h0l-.006-.144A1.783,1.783,0,0,0,9.494,8.248ZM10.115,0a2.667,2.667,0,0,1,2.7,2.635.993.993,0,0,0,.144.527,1.085,1.085,0,0,0,.662.5,1.111,1.111,0,0,0,.831-.107,2.735,2.735,0,0,1,3.6.949.772.772,0,0,1-.288,1.045.8.8,0,0,1-1.07-.272h0l-.071-.1A1.115,1.115,0,0,0,15.2,4.892a2.755,2.755,0,0,1-2.644-.028,2.626,2.626,0,0,1-1.35-2.22A1.049,1.049,0,0,0,10.9,1.87a1.1,1.1,0,0,0-.783-.324H8.883a1.111,1.111,0,0,0-.786.323,1.058,1.058,0,0,0-.312.775A2.582,2.582,0,0,1,6.442,4.874a2.709,2.709,0,0,1-2.65-.017h0l-.036-.035-.087-.061A.753.753,0,0,1,3.5,3.768a.8.8,0,0,1,1.079-.246,1.145,1.145,0,0,0,.54.149,1.113,1.113,0,0,0,.789-.283,1.061,1.061,0,0,0,.353-.745A2.665,2.665,0,0,1,8.883,0h1.232Z" fill="#fff" />
            </svg>

            <span className=" ">Settings</span>
          </li>
          <li>
            <svg id="help" xmlns="http://www.w3.org/2000/svg" width="23.5" height="23.5" viewBox="0 0 23.5 23.5">
              <path id="Path_9711" data-name="Path 9711" d="M0,0H23.5V23.5H0Z" fill="none" />
              <path id="Path_9712" data-name="Path 9712" d="M10.813,15.708h1.958v1.958H10.813ZM11.792,2a9.792,9.792,0,1,0,9.792,9.792A9.8,9.8,0,0,0,11.792,2Zm0,17.625a7.833,7.833,0,1,1,7.833-7.833A7.844,7.844,0,0,1,11.792,19.625Zm0-13.708A3.916,3.916,0,0,0,7.875,9.833H9.833a1.958,1.958,0,1,1,3.917,0c0,1.958-2.937,1.714-2.937,4.9h1.958c0-2.2,2.938-2.448,2.938-4.9A3.916,3.916,0,0,0,11.792,5.917Z" transform="translate(-0.042 -0.042)" fill="#fff" />
            </svg>

            <span className=" ">Help</span>
          </li>
        </ul>
      </aside>
    </SidebarContainer >
  );
}

const SidebarContainer = styled.div`
  text-align: center;

  a {
    text-decoration: none !important;
  }
 li svg{
    width:14px;
    height:14px;
    margin-right:15px;
  }
  a.active svg path {
    fill: #d4bdb4;
  }
  a.active span {
    color: #d4bdb4;
    padding-right: 10%;
  }

  .sidebar-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem 1.5rem;
  }
  .close-btn {
    font-size: 2rem;
    background: transparent;
    border-color: transparent;
    color: var(--clr-primary-5);
    transition: var(--transition);
    cursor: pointer;
    color: var(--clr-red-dark);
    margin-top: 0.2rem;
  }
  .close-btn:hover {
    color: var(--clr-red-light);
  }
  .logo {
    justify-self: center;
    height: 45px;
  }
  .burger {
    transform: translate(55px, 0px);
  }
  hr {
    margin: 0 15px 0 22px;
  }
  .subtitle {
    text-align: left;
    font: normal normal 600 12px/21px Poppins;
    letter-spacing: 0px;
    color: #d4bdb4;
    text-transform: Uppercase;
  }
  .links {
    font: normal normal 500 12px/20px Poppins;
    line-height: 27px;
    text-transform: Uppercase;
   
    color: white;
    list-style-type: none;
    text-align: left;
    padding-left: 24px;
  }
  .white-img path {
    fill: #ffffff;
  }
  .links a {
    display: block;
    text-align: left;
    font-size: 12px;
    text-transform: Uppercase;

    color: white;
    transition: var(--transition);
    letter-spacing: var(--spacing);
  }

  .links a:hover {
    background: var(--clr-grey-10);
    color: var(--clr-grey-2);
  }

  .sidebar {
    position: fixed;
    top: 0;
    left: 0;
    width: 230px;
    height: 100%;
    background: #1a1a1a;
    transition: var(--transition);
    transform: translate(-100%);
    z-index: -1;
  }
  .show-sidebar {
    transform: translate(0);
    z-index: 999;
  }
`;
